import _ from 'lodash';
import axios from 'axios';
import APIClient from './index';

export const getProductMentionQueue = params =>
  new Promise((resolve, reject) => {
    APIClient.get('ProductMentions/admin', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to load product mentions.'));
  });

export const getProductMentionDetail = id =>
  new Promise((resolve, reject) => {
    APIClient.get(`ProductMentions/admin/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to load the run record.'));
  });

export const getProductMentionRunDetail = id =>
  new Promise((resolve, reject) => {
    APIClient.get(`ProductMentions/admin/runs/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to load the run record.'));
  });

export const rejectProductMentionRuns = ids =>
  new Promise((resolve, reject) => {
    APIClient.put('ProductMentions/admin/runs/review', { ids, reviewStatus: 'rejected' })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to save the review.'));
  });

export const setProductMentionRunTag = (id, Product_id) =>
  new Promise((resolve, reject) => {
    APIClient.put(`ProductMentions/admin/runs/${id}/tag`, { Product_id })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to tag the product.'));
  });

export const retryProductMentionRuns = ids =>
  new Promise((resolve, reject) => {
    APIClient.put('ProductMentions/admin/runs/retry', { ids })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to requeue those posts.'));
  });

export const getProductMentionStats = () =>
  new Promise((resolve, reject) => {
    APIClient.get('ProductMentions/admin/stats')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to load pipeline stats.'));
  });

export const searchCatalogForRetag = q =>
  new Promise((resolve, reject) => {
    APIClient.get('ProductMentions/admin/catalog-search', { params: { q } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to search the catalog.'));
  });

export const searchProductMentionBrands = q =>
  new Promise((resolve, reject) => {
    APIClient.get('ProductMentions/admin/brand-search', { params: { q } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to search brands.'));
  });

export const setProductMentionReview = (ids, reviewStatus) =>
  new Promise((resolve, reject) => {
    APIClient.put('ProductMentions/admin/review', { ids, reviewStatus })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to save the review.'));
  });

export const setProductMentionExemplar = (id, isExemplar) =>
  new Promise((resolve, reject) => {
    APIClient.put(`ProductMentions/admin/${id}/exemplar`, { isExemplar })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to update the exemplar flag.'));
  });

export const setProductMentionQualityScore = (id, adminQualityScore, Product_id) =>
  new Promise((resolve, reject) => {
    APIClient.put(`ProductMentions/admin/${id}/quality-score`, { adminQualityScore, Product_id })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to save the quality grade.'));
  });

export const scoreProductMention = (id, { cancelToken } = {}) =>
  new Promise((resolve, reject) => {
    APIClient.post('ProductMentions/admin/score', { id }, { cancelToken })
      .then(response => resolve(response.data))
      .catch(err => {
        if (axios.isCancel(err)) return reject(err);
        reject(_.get(err, 'response.data.error') || _.get(err, 'response.data.msg') || 'Failed to score the mention.');
      });
  });

export const setProductMentionOverride = (id, { Product_id, reason }) =>
  new Promise((resolve, reject) => {
    APIClient.put(`ProductMentions/admin/${id}/override`, { Product_id, reason })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to save the override.'));
  });
